const ShipmentStatusEnum = {
  PUBLISHED: 'published',
  CONFIRMED: 'confirmed',
  REJECTED: 'rejected',
  IN_PROGRESS: 'inProgress',
  DELAYED: 'delayed',
  COMPLETED: 'completed'
}
export default ShipmentStatusEnum